import { withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { ReactTemplateSymbol } from './symbols'
import type { ImportMap, ReactTemplate } from './types'
import * as signals from '@preact/signals-react'

function createModuleUrl(code: string) {
	const blob = new Blob([code], { type: 'text/javascript' })
	return URL.createObjectURL?.(blob) || ''
}

export const ImportMapFactory = withDependencies(
	[ReactTemplateSymbol, BrowserWindowSymbol],
	(reactTemplate: ReactTemplate, browserWindow: BrowserWindow): ImportMap => {
		let importMap: Record<string, string> = {}

		if (browserWindow) {
			(browserWindow as any).signals = signals // TODO - https://wix.atlassian.net/browse/EDIX-31107
		}

		const mapScriptId = 'builder-module-loader-importmap'

		const defaultImportMap = {
			'react': createModuleUrl(reactTemplate.getReactModuleCode('window.React')),
			'react-dom': createModuleUrl(reactTemplate.getReactDOMModuleCode('window.ReactDOM')),
			'react/jsx-runtime': createModuleUrl(reactTemplate.getReactJsxRuntimeCode()),
			'react/jsx-dev-runtime': createModuleUrl(reactTemplate.getReactJsxDevRuntimeCode()),
			'@preact/signals-react': createModuleUrl(reactTemplate.getPreactSignalsReactModuleCode('window.signals')),
		}

		const updateImportMap = (dependencies: Record<string, string>) => {
			if (!browserWindow) {
				return
			}

			if (Object.keys(dependencies).length === 0) {
				return
			}

			importMap = {
				...importMap,
				...dependencies,
			}
		}

		const createImportMap = () => {
			if (!browserWindow) {
				return
			}

			updateImportMap(defaultImportMap)

			let mapScript = browserWindow.document.getElementById(mapScriptId) as HTMLScriptElement

			if (!mapScript) {
				mapScript = browserWindow.document.createElement('script')
				mapScript.id = mapScriptId
				mapScript.type = 'importmap'
				browserWindow.document.head.appendChild(mapScript)
			}

			mapScript.textContent = JSON.stringify({ imports: importMap })
		}

		return {
			updateImportMap: (dependencies: Record<string, string>) => {
				updateImportMap(dependencies)
				if (!browserWindow) {
					return
				}
				const mapScript = window.document.getElementById(mapScriptId) as HTMLScriptElement
				if (mapScript) {
					mapScript.textContent = JSON.stringify({ imports: importMap })
				}
			},
			createImportMap,
		}
	}
)
